import { Partner } from '../../../../apis/models/partner/res/Partner';
import Button from '../../../../components/atom/Button';

import { ReactComponent as IconEvent } from '../../../../assets/svgs/icon-event.svg';
import { ReactComponent as IconReservation } from '../../../../assets/svgs/icon-reservation.svg';
import { ReactComponent as ArrowDown } from '../../../../assets/custom-landing/arrow-down-brown.svg';
import KoLogoImage from '../../../../assets/custom-landing/nbom-landing-ko.png';
import EnLogoImage from '../../../../assets/custom-landing/nbom-landing-en.png';
import ZhLogoImage from '../../../../assets/custom-landing/nbom-landing-zh.png';
import BackgroundImage from '../../../../assets/custom-landing/nbom-landing-bg.png';
import strings from '../../../../constants/strings.constants';
import { Reveal } from 'react-awesome-reveal';
import { revealTransition } from '../renderer-utils';
import Typo from '../../../../components/atom/Typo';
import useLanguageCodeStore, {
  LanguageCode,
} from '../../../../store/useLanguageCodeStore';
export interface NbomLandingPageProps {
  partner?: Partner;
  buttonActions: {
    onEventMenuClick: () => void;
    onBookAppointmentClick: () => void;
    onReservationHistoriesClick: () => void;
  };
}

export default function NbomLandingPage(props: NbomLandingPageProps) {
  const { buttonActions } = props;
  const { languageCode } = useLanguageCodeStore();
  const renderButtons = (partner?: Partner) => {
    const eventMenuVisible =
      partner?.productViewConfig?.mimoWebViewConfig?.useThisMonthEventButton ??
      true;

    return (
      <>
        {eventMenuVisible && (
          <Button
            style={{
              background: '#5B4840',
            }}
            onClick={() => {
              buttonActions.onEventMenuClick();
            }}
          >
            <IconEvent />
            {strings.thisMonthEvent}
          </Button>
        )}

        <Button
          style={{
            background: '#5B48403B',
            fontWeight: 500,
            color: '#482B1F',
          }}
          onClick={() => {
            buttonActions.onBookAppointmentClick();
          }}
        >
          <IconReservation color="#482B1F" />
          {strings.bookAppointment}
        </Button>
        <Button
          style={{
            background: '#FFFFFF33',
            color: '#5B4840',
            fontWeight: 400,
          }}
          onClick={() => {
            buttonActions.onReservationHistoriesClick();
          }}
        >
          {strings.reservationHistoriesButton}
        </Button>
      </>
    );
  };

  return (
    <div
      className="flex flex-col justify-center h-full bg-[#f2ede8] relative"
      style={{
        background: `url(${BackgroundImage}) no-repeat center center`,
        backgroundSize: 'cover',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-black/5 via-black/0 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-tr from-black/5 via-transparent to-transparent" />
      <Reveal keyframes={revealTransition} duration={300}>
        <div className="flex flex-col gap-2 items-center">
          <div
            className="flex flex-col items-center px-[44px] pt-20 pb-10 min-h-[300px] max-w-[300px] relative"
            style={{
              borderRadius: '200px',
              border: '0.8px solid #5B4840',
            }}
          >
            {/* Border 겹침 */}
            <div
              className="absolute right-[1px] top-1/2 -translate-y-1/2 w-[calc(100%+8px)] h-[calc(100%+10px)] border-[0.8px] border-[#5B4840] rounded-full"
              style={{
                zIndex: 0,
              }}
            />
            <div className="flex flex-col items-center w-[160px] h-[100px]">
              <img
                width={160}
                src={logoImageMap[languageCode]}
                alt="logo"
                className="-mt-[20px]"
              />
            </div>
            <div
              className="flex flex-col gap-1 items-center mt-5 text-center"
              style={{
                whiteSpace: 'pre-wrap',
              }}
            >
              <Typo
                color="#5B4840"
                style={{
                  fontWeight: languageCode !== 'zh' ? 300 : 400,
                  fontSize: 17,
                }}
              >
                {strings.nbomLandingTitle1}
              </Typo>
              <Typo
                color="#5B4840"
                style={{
                  fontSize: 17,
                }}
              >
                {strings.nbomLandingTitle2}
              </Typo>
            </div>
            <div className="flex flex-col gap-1 items-center mt-[60px] text-center">
              <Typo
                style={{
                  color: '#A76352',
                  fontWeight: languageCode !== 'zh' ? 300 : 400,
                  fontSize: 14,
                  whiteSpace: 'pre',
                  lineHeight: '1.4',
                }}
              >
                {strings.nbomLandingReservationDescription}
              </Typo>
              <ArrowDown className="mt-4" />
            </div>
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-2 px-[20px] short:mt-5">
          {renderButtons()}
        </div>
      </Reveal>
    </div>
  );
}

const logoImageMap: Record<LanguageCode, string> = {
  [LanguageCode.ko]: KoLogoImage,
  [LanguageCode.en]: EnLogoImage,
  [LanguageCode.zh]: ZhLogoImage,
  [LanguageCode.ja]: EnLogoImage,
  [LanguageCode.zh_tw]: EnLogoImage,
  [LanguageCode.ms]: EnLogoImage,
  [LanguageCode.th]: EnLogoImage,
  [LanguageCode.id]: EnLogoImage,
  [LanguageCode.mn]: EnLogoImage,
  [LanguageCode.ru]: EnLogoImage,
};
